// config/routeConfig.ts - Fixed version with proper route matching


export interface RouteConfig {
  path: string;
  label: string;
  icon?: string;
  component?: string;
  children?: Record<string, RouteConfig>;
  dynamicLabel?: (context: Record<string, any>) => string;
  hideInSidebar?: boolean;
}

export const ROUTE_CONFIG: Record<string, RouteConfig> = {
  dashboard: {
    path: '/',
    label: 'Dashboard',
    icon: 'pi-home',
    component: 'Dashboard'
  },
  
  // instituteProfile: {
  //   path: '/institute-profile',
  //   label: 'Institute Profile',
  //   icon: 'pi-home',
  //   component: 'InstituteProfile'
  // },

  batches: {
  path: '/batches',
  label: 'Batches',
  icon: 'pi-users',
  component: 'Batches',
  children: {
    list: {
      path: '/batches',
      label: 'All Batches',
      component: 'Batches',
      hideInSidebar: true,
    },
    details: {
      path: '/batches/:batchId/details',
      label: 'Batch Details',
      component: 'BatchDetails',
      hideInSidebar: true,
    },
  },
},
  
  students: {
  path: '/students',
  label: 'Students',
  icon: 'pi-graduation-cap',
  children: {
    list: {
      path: '/students',
      label: 'All Students',
      component: 'Students',
      hideInSidebar: true,
    },
    addStudent: {
      path: '/students/add-student',
      label: 'Add New Student',
      component: 'AddStudent',
      hideInSidebar: true,
    },
    editStudent: {  // ← ADD THIS
      path: '/students/edit/:studentId',
      label: 'Edit Student',
      component: 'EditStudent',
      hideInSidebar: true,
    },
    details: {
      path: '/students/:studentId',
      label: 'Student Details',
      component: 'StudentDetails',
      hideInSidebar: true,
    },
    enrollment: {
      path: '/students/add-student',
      label: 'Add New Student',
      component: 'AddStudent',
      hideInSidebar: true,
    },
  },
},


  

  teachers: {
  path: '/teachers',
  label: 'Teachers',
  icon: 'pi-users',
  children: {
    list: {
      path: '/teachers',
      label: 'All Teachers',
      component: 'Teachers',
      hideInSidebar: true,
    },
    addTeacher: {
      path: '/teachers/add-teacher',
      label: 'Add New Teacher',
      component: 'AddTeacher',
      hideInSidebar: true,
    },
    editTeacher: {  // NEW
      path: '/teachers/edit/:teacherId',
      label: 'Edit Teacher',
      component: 'EditTeacher',
      hideInSidebar: true,
    },
    details: {  // NEW
      path: '/teachers/:teacherId',
      label: 'Teacher Details',
      component: 'TeacherDetails',
      hideInSidebar: true,
    },
  },
},
  

assignments: {
  path: '/assignments',
  label: 'Assignments',
  icon: 'pi-file-edit',
  component: 'AssignmentBoard',
  children: {
    list: {
      path: '/assignments',
      label: 'Assignments',
      component: 'AssignmentBoard',
      hideInSidebar: true,
    },
    details: {
      path: '/assignments/:assignmentId/details',
      label: 'Assignment Details',
      component: 'AssignmentDetails',
      hideInSidebar: true,
    },
  },
},
  
  noticeboard: {
    path: '/noticeboard',
    label: 'NoticeBoard',
    icon: 'pi-bell',
    component: 'NoticeBoard'
  },

  studymaterials: {
    path: '/study-materials',
    label: 'StudyMaterials',
    icon: 'pi-book',
    component: 'StudyMaterials'
  },

    practicalmaterials: {
    path: '/practical-materials',
    label: 'Practical Materials',
    icon: 'pi-file',
    component: 'PracticalMaterials'
  },

  IdCardGenerator: {
    path: '/id-card-generator',
    label: 'Id Card Generator',
    icon: 'pi-id-card',
    component: 'IdCardGenerator'
  },

  StudentsFees: {
    path: '/students-fees',
    label: 'Fees',
    icon: 'pi-indian-rupee',
    component: 'StudentsFees'
  },


Results: {
  path: '/results',
  label: 'Results',
  icon: 'pi-indian-rupee',
  component: 'RecordMarks',
  children: {
    list: {
      path: '/results',
      label: 'Results',
      component: 'RecordMarks',
      hideInSidebar: true,
    },
    RecordMarks: {
      path: '/results/marks-recorder',
      label: 'Marks Recorder',
      component: 'RecordMarks',
      hideInSidebar: false,
    },
    DocumentGenerator: {
      path: '/results/document-generator',
      label: 'Document Generator',
      component: 'DocumentGenerator',
      hideInSidebar: false,
    },
  },
},


   Exams: {
  path: '/exams',
  label: 'Exams',
  icon: 'pi-users',
  component: 'Exams',
  children: {
    list: {
      path: '/exams',
      label: 'Exams',
      component: 'Exams',
      hideInSidebar: true,
    },
    CreateClassTest: {
      path: '/exams/create-class-test',
      label: 'Create Test',
      component: 'CreateClassTest',
      hideInSidebar: false,
    },
    ClassTestList: {
      path: '/exams/class-tests',
      label: 'Class Tests',
      component: 'ClassTestList',
      hideInSidebar: false,
    },
    ViewClassTest: {
    path: '/exams/class-tests/:id',
    label: 'View Class Test',
    component: 'ViewClassTest',
    hideInSidebar: true,
  },
  },
},

attendance: {
  path: '/attendance',
  label: 'Attendance',
  icon: 'pi-calendar-clock',
  component: 'OperatorAttendance'
},

 

  

  
  
  
  settings: {
    path: '/settings/teacher-permissions',
    label: 'Settings',
    icon: 'pi-cog',
    component: 'TeacherPermissionsSettings'
  },
  
};

// Helper functions to work with the route configuration

export interface BreadcrumbItem {
  id: string;
  label: string;
  path: string;
}

/**
 * Flatten all routes for easier lookup
 */
const flattenRoutes = (
  config: Record<string, RouteConfig> = ROUTE_CONFIG,
  parentId?: string
): Array<{ id: string; route: RouteConfig; parent?: string }> => {
  const flattened: Array<{ id: string; route: RouteConfig; parent?: string }> = [];
  
  for (const [id, route] of Object.entries(config)) {
    flattened.push({ id, route, parent: parentId });
    
    if (route.children) {
      flattened.push(...flattenRoutes(route.children, id));
    }
  }
  
  return flattened;
};

// Cache the flattened routes
const FLATTENED_ROUTES = flattenRoutes();

/**
 * Find a route configuration by its path
 * IMPROVED: Uses flattened routes and prioritizes longer, more specific paths
 */
export const findRouteByPath = (
  path: string
): { id: string; route: RouteConfig; parent?: string } | null => {
  // Sort by path length (descending) to match more specific paths first
  const sortedRoutes = [...FLATTENED_ROUTES].sort((a, b) => 
    b.route.path.length - a.route.path.length
  );
  
  for (const { id, route, parent } of sortedRoutes) {
    // Try exact match first
    if (route.path === path) {
      return { id, route, parent };
    }
    
    // Then try pattern matching for dynamic routes
    const pathPattern = route.path.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${pathPattern}$`);
    
    if (regex.test(path)) {
      return { id, route, parent };
    }
  }
  
  return null;
};

/**
 * Find a route configuration by its ID
 */
export const findRouteById = (
  id: string,
  config: Record<string, RouteConfig> = ROUTE_CONFIG,
  parentId?: string
): { route: RouteConfig; parent?: string } | null => {
  if (config[id]) {
    return { route: config[id], parent: parentId };
  }
  
  for (const [currentId, route] of Object.entries(config)) {
    if (route.children) {
      const result = findRouteById(id, route.children, currentId);
      if (result) return result;
    }
  }
  
  return null;
};

/**
 * Build breadcrumb trail from root to current route
 */
export const buildBreadcrumbTrail = (
  currentPath: string,
  context: Record<string, any> = {}
): BreadcrumbItem[] => {
  const trail: BreadcrumbItem[] = [];
  
  // Always start with dashboard
  trail.push({
    id: 'dashboard',
    label: 'Dashboard',
    path: '/'
  });
  
  // Find current route
  const current = findRouteByPath(currentPath);
  if (!current || current.id === 'dashboard') {
    return trail;
  }
  
  // Build parent chain
  const buildChain = (parentId?: string): string[] => {
    if (!parentId) return [];
    
    const parent = findRouteById(parentId);
    if (!parent) return [];
    
    const chain = buildChain(parent.parent);
    chain.push(parentId);
    return chain;
  };
  
  const parentChain = buildChain(current.parent);
  
  // Add parents to trail
  for (const parentId of parentChain) {
    const parentResult = findRouteById(parentId);
    if (parentResult) {
      const label = parentResult.route.dynamicLabel
        ? parentResult.route.dynamicLabel(context)
        : parentResult.route.label;
      
      trail.push({
        id: parentId,
        label,
        path: parentResult.route.path
      });
    }
  }
  
  // Add current route
  const label = current.route.dynamicLabel
    ? current.route.dynamicLabel(context)
    : current.route.label;
  
  trail.push({
    id: current.id,
    label,
    path: current.route.path
  });
  
  return trail;
};

/**
 * Get all routes for sidebar (excluding hidden ones)
 */
export const getSidebarRoutes = (
  config: Record<string, RouteConfig> = ROUTE_CONFIG
): Array<{ id: string; route: RouteConfig; children?: Array<{ id: string; route: RouteConfig }> }> => {
  const routes: Array<{
    id: string;
    route: RouteConfig;
    children?: Array<{ id: string; route: RouteConfig }>;
  }> = [];
  
  for (const [id, route] of Object.entries(config)) {
    if (route.hideInSidebar) continue;
    
    const item: any = { id, route };
    
    if (route.children) {
      item.children = [];
      for (const [childId, childRoute] of Object.entries(route.children)) {
        if (!childRoute.hideInSidebar) {
          item.children.push({ id: childId, route: childRoute });
        }
      }
    }
    
    routes.push(item);
  }
  
  return routes;
};

/**
 * Check if a route or its children are active
 */
export const isRouteActive = (
  routeId: string,
  currentPath: string
): boolean => {
  const current = findRouteByPath(currentPath);
  if (!current) return false;
  
  // Direct match
  if (current.id === routeId) return true;
  
  // Check if current route is a child of routeId
  const buildParentChain = (parentId?: string): string[] => {
    if (!parentId) return [];
    
    const parent = findRouteById(parentId);
    if (!parent) return [];
    
    const chain = buildParentChain(parent.parent);
    chain.push(parentId);
    return chain;
  };
  
  const parentChain = buildParentChain(current.parent);
  return parentChain.includes(routeId);
};

/**
 * Navigate to a route by ID
 */
export const getPathForRoute = (
  routeId: string,
  params: Record<string, string> = {}
): string => {
  const result = findRouteById(routeId);
  if (!result) return '/';
  
  let path = result.route.path;
  
  // Replace dynamic params
  for (const [key, value] of Object.entries(params)) {
    path = path.replace(`:${key}`, value);
  }
  
  return path;
};